// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.encounter.dynamic.AddDynamicTestToDynamicScreenRequest */
/* istanbul ignore next */
@GandalfModel
export class AddDynamicTestToDynamicScreenRequest extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	leftPosition!: number | null;

	@GandalfProperty({ designType: Number })
	topPosition!: number | null;

	@GandalfValidator({ notNull: { message: 'Screen is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	workflowScreenId!: number;

	@GandalfValidator({ notNull: { message: 'Test Template is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	workflowTestTemplateId!: number;

}
